import { useChatContext } from './chat-context';

export type ChatTriggerSource = {
  sourceId: number;
  sourceType: string;
  timestamp?: string;
};

export type ChatTriggerData = {
  message: string;
  elementContext: string;
  sourceType: string;
  sourceId: number;
  sources?: ChatTriggerSource[];
};

// Global variable to store the chat trigger function
let globalChatTrigger: ((data: ChatTriggerData) => void) | null = null;

// Hook to register the chat trigger function
export const useChatTrigger = () => {
  const { openChatWithData } = useChatContext();

  // Register the function globally when this hook is used
  globalChatTrigger = openChatWithData;

  return openChatWithData;
};

// Function that can be called from anywhere (including extensions)
export const triggerChat = (data: ChatTriggerData) => {
  if (globalChatTrigger) {
    globalChatTrigger(data);
  } else {
    // Fallback to custom event if context is not available
    window.dispatchEvent(
      new CustomEvent('openChatPane', {
        detail: data,
      }),
    );
  }
};
